import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import MerchantPageShell from "../../components/merchant/MerchantPageShell";
import { login } from "../../lib/shopperAuthApi";
import { clearToken, clearVeyaTeamToken } from "../../lib/api";
import { useSession } from "../../hooks/useSession";

export default function ShopperLogin({ rightAction }) {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/browse";
  const { refreshSession } = useSession();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const email = form.email.trim();
    const password = form.password.trim();

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      clearToken();
      clearVeyaTeamToken();

      await login({ email, password });
      await refreshSession();
      navigate(from, { replace: true });
    } catch (err) {
      console.error("Shopper login failed", err);
      setError(err?.message || "Could not sign in.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <MerchantPageShell rightAction={rightAction}
      eyebrow="Shopper Account"
      title="Sign in"
      lede="Access your avatar, saved edits, and wardrobe."
    >
      <form className="merchant-form" onSubmit={handleSubmit}>
        <label className="merchant-field">
          <span className="merchant-label">Email</span>
          <input
            className="merchant-input"
            type="email"
            value={form.email}
            onChange={(e) => updateField("email", e.target.value)}
            placeholder="hello@youremail.com"
            autoComplete="email"
          />
        </label>

        <label className="merchant-field">
          <span className="merchant-label">Password</span>
          <input
            className="merchant-input"
            type="password"
            value={form.password}
            onChange={(e) => updateField("password", e.target.value)}
            placeholder="Enter your password"
            autoComplete="current-password"
          />
        </label>

        {error ? <p className="merchant-error">{error}</p> : null}

        <div className="merchant-actions">
          <button className="gold-btn" type="submit" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>

          <p
            style={{
              margin: 0,
              fontSize: 15,
              color: "rgba(43, 43, 43, 0.78)",
              display: "flex",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
            }}
          >
            <span>Don’t have an account?</span>
            <Link
              to="/signup"
              style={{
                color: "#5b1f2b",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              Create one
            </Link>
          </p>
        </div>
      </form>
    </MerchantPageShell>
  );
}